import { module as m } from 'modujs';
import { html, main, transition } from './../../utils/environment';
import barba from '@barba/core';
import gsap from 'gsap';
import LocomotiveScroll from 'locomotive-scroll';
import imagesLoaded from 'imagesloaded';
import {StoreSingleton} from "../../singletons/store";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.enabledSmoothScroll = main.dataset.scrollContainer;
        this.lastY = 0;
        this.scroll = null;
        this.scrollArgs = {
            el: main,
            smooth: true,
            offset: ['20%'],
            lerp: 0.15,
            firefoxMultiplier: 70,
            getDirection: true,
            reloadOnContextChange: true,
            tablet: {
                breakpoint: 1024,
            }
        };
    }

    init() {

        // First scroll instance
        if(this.enabledSmoothScroll != undefined)
            this.createScroll();

        barba.hooks.afterLeave((data) => {
            if(this.scroll)
                this.scroll.destroy();
        });

        barba.hooks.enter((data) => {

            this.call('destroy', data.current.container, 'app');
            this.call('update', data.next.container, 'app');

            // Remove
            html.classList.remove('has-dom-ready');
        });

        barba.hooks.after((data) => {

            if(StoreSingleton.isMobile)
                this.call('close', {}, 'MenuMobile');

            // SCROLL
            window.scroll(0, 0);

            setTimeout(() => {
                this.createScroll();
                html.classList.add('has-dom-ready');
            }, 450);
        });

        barba.init({
            transitions: [
                {
                    name: 'default',
                    leave(data) {
                        console.log('** TRANSITION ::: LEAVE **');
                        transition.classList.add('visible');
                        const _tl = gsap.timeline();
                        _tl.set(transition.querySelector('.transition__circle'), {
                            y: '100vh',
                            borderRadius: '60%'
                        });
                        _tl.to(transition.querySelector('.transition__circle'), {
                            duration: 1.4,
                            borderRadius: '0',
                            y: '-10%',
                            ease: 'power4.inOut'
                        }, 0)
                        return _tl;
                    },
                    after(data) {
                        console.log('** TRANSITION ::: AFTER **');
                        const _tl = gsap.timeline({
                            onComplete: () => {
                                transition.classList.remove('visible');
                            }
                        });
                        _tl.set(transition.querySelector('.transition__circle'), {
                            borderRadius: '60%'
                        });
                        _tl.to(transition.querySelector('.transition__circle'), {
                            duration: 1.4,
                            borderRadius: '0',
                            y: '-100%',
                            ease: 'power4.inOut'
                        }, 0)
                        return _tl;
                    }
                }, {
                    name: 'introduction',
                    beforeOnce(data) {
                        console.log('** TRANSITION ::: BEFORE ONCE **');
                    },
                    once(data) {
                        console.log('** TRANSITION ::: ONCE **');
                    },
                    afterOnce(data) {
                        const _tl = gsap.timeline({
                            onComplete: () => {
                                html.classList.remove('is-first-load');
                                transition.classList.remove('visible');
                            }
                        });
                       _tl.to(transition.querySelector('.transition__circle'), {
                           duration: 1.4,
                           borderRadius: '0',
                            y: '-100%',
                           ease: 'power4.inOut'
                       })
                        return _tl;
                    }
                }]
        });

        setTimeout(() => {
            this.scroll.update();
            html.classList.add('has-dom-ready');
            this.call('enter', {}, 'Header');
        }, 450);
    }

    /**
     * Create scroll
     */
    createScroll() {
        console.log('** LOAD :: CREATE SCROLL **');
        this.scroll = new LocomotiveScroll(this.scrollArgs);

        this.scroll.on('call', (func, way, elt) => {
            //console.log(func[0], {elt, way, params: func[1]}, func[2], func[3]);
            this.call(func[0], {elt, way, params: func[1]}, func[2], func[3]);
        });

        this.scroll.on('scroll', (args) => {
            window.deadwater.scroll = args;

            if(!StoreSingleton.isMobile) {
                const _direction = args.scroll.y >= this.lastY ? 1 : -1;

                // HEADER
                if(_direction === 1 && args.scroll.y > 100)
                    this.call('hide', {}, 'Header');
                else if(_direction === -1 && args.scroll.y < (this.lastY - 1)) {
                    this.call('show', {}, 'Header');
                }

                // FOOTER / BLOCK NEXT PAGE
                const maxScroll = document.body.offsetHeight - window.innerHeight;
                if(_direction === 1 && args.scroll.y > (maxScroll - 50)) {
                    this.call('show', {}, 'NextPage');
                } else {
                    this.call('hide', {}, 'NextPage');
                }

                this.lastY = args.scroll.y;
            }
        });

        imagesLoaded( document.body, (instance) => {
            console.log('** LOAD :: ALL IMAGES COMPLETE **');
            this.update();
        });
    }

    /**
     * START PAGE
     * @param i__modules
     */
    startPage(i__modules) {
        if(i__modules) {
            const _pageClass = findValueByPrefix(i__modules, 'module');
            this.call('start', {}, _pageClass);
        }
    }

    /**
     * UPDATE
     */
    update() {
        if(this.scroll)
            this.scroll.update();
    }

    /**
     * SCROLL TO
     * @param i__target
     */
    scrollTo(i__target) {
        this.scroll.scrollTo(i__target, {
            offset: -200
        });
    }
}
